<template lang="pug">
modal#canceled-envelope-modal(
  :process-button-label='$t("button.ok")'
  :show-cancel-button='false'
  :title='$t("modal.canceledEnvelope.title")'
  @process='closeModal'
  ref='modal'
  size='sm'
)
  p.justify-center {{ $t('modal.canceledEnvelope.message') }}
  .text-center.my-4
    img.img-fluid(src='/img/ilustrations/canceled-rejected-envelope.svg')
</template>
<script>
import Modal from '@/ui/molecules/Modal.vue';

export default {
  name: 'CancelEnvelopeModal',
  components: {
    Modal,
  },
  methods: {
    closeModal() {
      this.$refs.modal.close();
    },
  },
};
</script>
